module.exports = __webpack_public_path__ + "static/media/lagrase.a5c40b5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/tiendamia/lagrase.jpg
// module id = 1200
// module chunks = 0